import React, { useState } from 'react'

import { useRequest } from 'ahooks'

import styles from './SegmentBrowser.module.scss'

export default function SegmentBrowser() {
  const [error, setError] = useState<string | null>(null)
  const { data, loading, refresh } = useRequest(
    () =>
      fetch('/api/customerio/list-segments/').then((res) => {
        if (res.ok) {
          return res.json()
        }
        throw new Error(`${res.status} - ${res.statusText}`)
      }),
    {
      onError: (e) => {
        setError(e.message)
      },
    },
  )

  if (loading || !data) {
    return <div>Loading...</div>
  }

  if (error) {
    return <div className={styles.error}>Error: {error}</div>
  }

  return (
    <div>
      <h3 className={styles.title}>List of segments</h3>
      <div className={styles.tableContainer}>
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
            </tr>
          </thead>
          <tbody>
            {(data?.segments || [])
              .sort((a, b) => b.id - a.id)
              .map((segment: any, ix: number) => (
                <tr
                  key={segment.id}
                  className={ix % 2 === 0 ? styles.evenRow : styles.oddRow}
                >
                  <td>{segment.id}</td>
                  <td>{segment.name}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <button onClick={refresh}>Refresh</button>
    </div>
  )
}
